// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__1Cevk","gridContainer":"Entity_gridContainer__1UZw8","icon":"Entity_icon__cyvqL","content":"Entity_content__3j1a8","value":"Entity_value__2ncVy"};